import Icon from '@forwardflow/ui/Icons'
import { Avatar } from 'antd'
import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { AccessPermissionItem } from '../AccessPermissionItem'

interface UserListItemProps {
   name: string
   role: string
   isAdded: boolean
   email: string
   hideActionButton?: boolean
   onSelectionChange: (isSelected: boolean) => void
   isSelected?: boolean
   onPermissionChange?: (
      userId: string,
      permission: 'yes' | 'no' | null
   ) => void
   userId: string
   defaultPermission?: 'yes' | 'no' | null
   showPermissionButtons?: boolean
   isWhitelist?: boolean
}

export const UserListItem: React.FC<UserListItemProps> = ({
   name,
   role,
   isAdded,
   email,
   hideActionButton = false,
   onPermissionChange,
   userId,
   defaultPermission = null,
   showPermissionButtons = false,
   isWhitelist = false,
}) => {
   const initials = name
      ?.split(' ')
      ?.map((part) => part?.charAt(0))
      ?.join('')

   const avatarColor = useMemo(() => {
      const hash = name?.split('')?.reduce((acc, char) => {
         return char?.charCodeAt(0) + ((acc << 5) - acc)
      }, 0)

      const colors = [
         '#f56a00',
         '#7265e6',
         '#ffbf00',
         '#00a2ae',
         '#712704',
         '#04B404',
         '#0174DF',
         '#8A0886',
         '#DF0101',
         '#04B4AE',
      ]

      const colorIndex = Math.abs(hash) % colors.length
      return colors[colorIndex]
   }, [name])

   const handlePermissionChange = (permission: 'yes' | 'no' | null) => {
      onPermissionChange?.(userId, permission)
   }

   return (
      <Link
         to={email ? `/settings/user-management/${email}` : '#'}
         className="flex items-center h-[62px] pl-10 bg-primary/10 hover:bg-primary/20  hover:primary/20 overflow-hidden group cursor-pointer"
      >
         <Avatar
            className="w-10 h-10 mr-4 font-semibold"
            style={{ backgroundColor: avatarColor }}
         >
            {initials}
         </Avatar>
         <p className="mr-auto font-medium">{name}</p>
         {role?.toLowerCase() === 'admin' && (
            <p className="text-[12px] text-white/70 py-1 px-2 ml-4 bg-black/20">
               {role}
            </p>
         )}
         {isWhitelist && (
            <p className="text-[12px] bg-black/20 py-1 px-2 rounded mr-10">
               Selected
            </p>
         )}

         {showPermissionButtons && (
            <div
               className="h-full pr-10 flexc"
               onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
               }}
            >
               <AccessPermissionItem
                  onPermissionChange={handlePermissionChange}
                  defaultPermission={defaultPermission}
               />
            </div>
         )}

         {hideActionButton && (
            <div className="items-center hidden ml-auto font-medium group-hover:hidden">
               {isAdded ? (
                  <button className="h-10 ml-2  transition-all border rounded w-28 border-[#C11574] bg-[#C11574]/20 hover:bg-[#C11574]/40">
                     Remove
                  </button>
               ) : (
                  <div className="w-24 gap-1 flexc">
                     <button
                        onClick={(e) => {
                           e.preventDefault()
                           e.stopPropagation()
                        }}
                        className="w-10 h-10 rounded-[2px] flexc bg-black/10 shrink-0"
                     >
                        <Icon name="Delete" className="fill-[#FF5185]" />
                     </button>
                     <Icon name="arrow-down" className="ml-4 -rotate-90" />
                  </div>
               )}
            </div>
         )}
      </Link>
   )
}
